angular.module('randomization')
    .controller('EntityMenuRandomizationController', ['RecordRandomizationService', 'StudyContext', '$scope', function(RecordRandomizationService, StudyContext, $scope) {
        var vm = this;

        vm.randomized = RecordRandomizationService.isRandomized();

        $scope.$on('RecordRandomized', function() {
            vm.randomized = RecordRandomizationService.isRandomized();
        });
    }]);
